import React from "react";
import MarketingLayout from "../../components/layout/marketing/MarketingLayout";

export default function Privacy() {
    const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL;
    return (
        <MarketingLayout>
            <div className="mx-auto px-8 lg:px-24 py-20 sm:py-24 lg:py-16">
                {/* Header with Brand Styling */}
                <div className="border-b border-border-subtle pb-8">
                    <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-text-primary">
                        Privacy <span className="bg-brand-gradient bg-clip-text text-transparent">Policy</span>
                    </h1>
                    <p className="mt-4 text-lg text-text-muted">Last Updated: January 2026</p>
                </div>

                <div className="mt-12 space-y-12">
                    {/* Intro */}
                    <div className="prose prose-slate max-w-none">
                        <p className="text-lg leading-relaxed text-text-secondary">
                            At Eikos Health, we recognize that trust is the foundation of healthcare. This policy
                            outlines how we handle data as a technology partner to your clinical practice.
                        </p>
                    </div>

                    {/* Section 1: Data Ownership */}
                    <article>
                        <h2 className="text-2xl font-semibold text-text-primary flex items-center gap-3">
                            <span className="h-8 w-1 bg-primary rounded-full" />
                            1. Data Ownership & Processing
                        </h2>
                        <div className="mt-4 bg-bg-subtle/30 p-6 rounded-2xl border border-border-subtle">
                            <p className="text-text-secondary leading-relaxed">
                                <strong>You retain full ownership</strong> of all patient records and Personal Health
                                Information (PHI) entered into Eikos Health. We act strictly as a{" "}
                                <strong>"Data Processor"</strong> on your behalf. We never sell, lease, or share patient
                                data for advertising or third-party marketing purposes.
                            </p>
                        </div>
                    </article>

                    {/* Section 2: WhatsApp Integration */}
                    <article>
                        <h2 className="text-2xl font-semibold text-text-primary flex items-center gap-3">
                            <span className="h-8 w-1 bg-primary rounded-full" />
                            2. Messaging & WhatsApp Privacy
                        </h2>
                        <p className="mt-4 text-text-secondary leading-relaxed">
                            Our service operates via the WhatsApp Business API. While we employ industry-standard
                            encryption within our platform, data transmission over third-party networks (WhatsApp) is
                            subject to Meta’s security protocols. You are responsible for ensuring patients have
                            opted-in to receive communications via this channel.
                        </p>
                    </article>

                    {/* Section 3: Information Collection */}
                    <article>
                        <h2 className="text-2xl font-semibold text-text-primary flex items-center gap-3">
                            <span className="h-8 w-1 bg-primary rounded-full" />
                            3. Information Collection
                        </h2>
                        <ul className="mt-4 grid gap-4 md:grid-cols-2">
                            {[
                                {
                                    title: "Account Data",
                                    desc: "Practitioner name, clinic details, and login credentials."
                                },
                                {
                                    title: "Metadata",
                                    desc: "Appointment times, booking sources, and system usage logs."
                                },
                                {
                                    title: "Integration Data",
                                    desc: "WhatsApp phone numbers and API keys required for bot operation."
                                },
                                {
                                    title: "Billing Info",
                                    desc: "Subscription status and payment history via our secure gateways."
                                }
                            ].map((item, i) => (
                                <li key={i} className="p-4 border border-border-subtle rounded-xl bg-white shadow-sm">
                                    <h3 className="font-bold text-text-primary">{item.title}</h3>
                                    <p className="text-sm text-text-muted mt-1">{item.desc}</p>
                                </li>
                            ))}
                        </ul>
                    </article>

                    {/* Section 4: Security Standards */}
                    <article>
                        <h2 className="text-2xl font-semibold text-text-primary flex items-center gap-3">
                            <span className="h-8 w-1 bg-primary rounded-full" />
                            4. Security Standards
                        </h2>
                        <p className="mt-4 text-text-secondary leading-relaxed">
                            We use AES-256 encryption at rest and TLS encryption in transit. Access to our database is
                            strictly restricted to authorized personnel required for technical maintenance. In
                            compliance with local regulations (such as the DPDP Act), we maintain rigorous audit logs of
                            data access.
                        </p>
                    </article>

                    {/* Section 5: Contact */}
                    <article className="bg-primary/5 border border-primary/20 p-8 rounded-3xl text-center">
                        <h2 className="text-xl font-semibold text-text-primary">Questions or Concerns?</h2>
                        <p className="mt-2 text-text-secondary text-sm">Our Privacy Officer is available at:</p>
                        <a
                            href={`mailto:${supportEmail}`}
                            className="mt-4 inline-block text-primary font-bold hover:underline"
                        >
                            {supportEmail}
                        </a>
                    </article>
                </div>
            </div>
        </MarketingLayout>
    );
}
